import { JSONUtils } from '../../utility/json-utils.js';
import { MapUtils } from '../../utility/map-utils.js';
import { isSameList } from '../dto/data-model-utils.js';
import {
  DataModel, DataModelBuilder, SerializationContext, SerializedData,
} from '../dto/data-model.js';

export class EventProfileAssociations extends DataModel {
  static readonly TYPE_ID: string = 'c0df506b15ee4179876da8bf04c947ef';

  private constructor(
    public readonly artists: string[],
    public readonly brands: string[],
    public readonly organizers: string[],
  ) {
    super();
  }

  get $typeId(): string {
    return EventProfileAssociations.TYPE_ID;
  }

  static create(args: {
    artists: string[],
    brands: string[],
    organizers: string[],
  }): EventProfileAssociations {
    return new EventProfileAssociations(
        args.artists,
        args.brands,
        args.organizers,
    );
  }

  static fromMap(
      context: SerializationContext,
      map: SerializedData,
  ): EventProfileAssociations {
    return EventProfileAssociations.create({
      artists: MapUtils.getList<string>(map, 'artists', (x) => JSONUtils.decodeString(x)),
      brands: MapUtils.getList<string>(map, 'brands', (x) => JSONUtils.decodeString(x)),
      organizers: MapUtils.getList<string>(map, 'organizers', (x) => JSONUtils.decodeString(x)),
    });
  }

  static empty(): EventProfileAssociations {
    return EventProfileAssociations.create({
      artists: [],
      brands: [],
      organizers: [],
    });
  }

  toMap(context: SerializationContext): SerializedData {
    return {
      artists: this.artists,
      brands: this.brands,
      organizers: this.organizers,
    };
  }

  clone(): this {
    return new EventProfileAssociations(
        this.artists.slice(),
        this.brands.slice(),
        this.organizers.slice(),
    ) as this;
  }

  isSame(other: this): boolean {
    if(other === this) {
      return true;
    }

    return isSameList(other.artists, this.artists) &&
        isSameList(other.brands, this.brands) &&
        isSameList(other.organizers, this.organizers);
  }
}

export class EventProfileAssociationsBuilder extends DataModelBuilder<EventProfileAssociations> {
  build(context: SerializationContext, map: SerializedData): EventProfileAssociations {
    return EventProfileAssociations.fromMap(context, map);
  }
}
